export default __webpack_public_path__ + "static/media/04MAR.d8daa8a0.jpg";